<template>
    <v-app id="inspire">
    <v-content>
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
            <v-flex xs12 sm8 md8 lg4>
                <v-card class="elevation-5 pa-3">
                <v-card-text>
                    <div class="layout column align-center">
                    <img :src="getLogo" alt="Nadzorni center - Ponastavitev gesla" width="25%" height="auto">
                    <br>
                    <!--<h1 class="flex mb-2 font-weight-regular">Nadzorni center</h1>-->
                    <h2 class="flex my-2 font-weight-regular">Nadzorni center - Ponastavitev gesla</h2>
                    <v-layout align-center justify-center="">
                        <v-flex xs12 sm12 md10 lg10>
                            <div class="">
                                <p style="text-align:center;">Za ponastavitev gesla vnesite svoj elektronski naslov. Na vaš elektronski naslov vam bodo poslana nadaljna navodila za ponastavitev vašega gesla.</p>
                            </div>
                        </v-flex>
                    </v-layout>
                    </div>                
                    <br><br>
                    <v-form v-model="valid" ref="resetForm" >
                    <v-text-field append-icon="email" @keyup.esc="clearEmailInput" @keyup.enter="sendRequest" name="email" label="Vaš elektronski naslov" type="email" v-model="email" color="tertiary" :rules="[rules.required, rules.email]" clearable=""></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn  class="white--text" dark color="secondary" @click="redirectToLogin">Prijava</v-btn>
                    <v-btn  class="white--text" dark color="secondary" @click.native="sendRequest" :loading="loading">Ponastavi geslo</v-btn>
                </v-card-actions>
                </v-card>
            </v-flex>
            </v-layout>
        </v-container>

        <v-snackbar
            auto-height
            v-model="$store.getters.snackbar.display"
            :bottom="$store.getters.snackbar.y === 'bottom'"
            :left="$store.getters.snackbar.x === 'left'"
            :multi-line="$store.getters.snackbar.mode === 'multi-line'"
            :right="$store.getters.snackbar.x === 'right'"
            :timeout="$store.getters.snackbar.timeout"
            :top="$store.getters.snackbar.y === 'top'"
            :vertical="$store.getters.snackbar.mode === 'vertical'"
            >
            {{ $store.getters.snackbar.text }}
            <v-btn
                color="pink"
                flat
                @click="snackbar"
            >
                Zapri
                </v-btn>
        </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
import logo from '@/assets/logo.png'
export default {
    components: {
    },
    data: () => ({
        email: null,
        loading: false,
        rules: {
            required: value => !!value || 'Polje za vnos elektronskega naslova je obvezno',
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Elektronski naslov je neveljaven'
            }
        },
        valid: false
    }),

    watch: {
        email(value) {
            if(this.email == null) {
                this.email = ''
                this.$refs.resetForm.resetValidation()
            }
        }
    },

    computed: {
        getLogo() {
            return 'https://cloud.conforma.si/public/img/blejski-grad/blejski_grad_logo2.jfif'
        }
    },

    methods: {
        sendRequest() {
            this.$refs.resetForm.validate();
            //console.log(this.valid)
            if(this.valid) {
                this.loading = true
                this.$store.dispatch('PASSWORD_RESET_REQUEST', { email: this.email, secret: '33baa9e6-244b-4832-88e6-34035f603e43' })
                .then(response => {
                    //console.log(response)
                    this.email = null
                    this.loading = false
                    this.$store.commit('snackbarText', 'Na vaš elektronski naslov so vam bila poslana poslana navodila za ponastavitev vašega gesla')
                    this.$store.commit('snackbarDisplay', true) 
                })
                .catch(error => {
                    console.log(error)
                    this.loading = false
                    if(error.response.status == 403) {
                        this.$store.commit('snackbarText', 'Uporabnik s tem elektronskim naslovom ne obstaja')
                    } else {
                        this.$store.commit('snackbarText', 'Pri ponastavitvi gesla je prišlo do napake')
                    }

                    this.$store.commit('snackbarDisplay', true) 
                })
            }
        },

        redirectToLogin() {
            this.$router.push({
                name: 'login'
            })
        },

        clearEmailInput() {
            this.email = null
            this.$refs.resetForm.resetValidation()
        },

        snackbar() {
            this.$store.state.snackbar.display = false
        },
    },

    created() {

    },

    mounted() {
        //console.log(this.valid)
    },

    destroyed() {
        this.$store.commit('snackbarDisplay', false) 
    }
}
</script>

<style scoped lang="css">
    html { overflow-y: auto !important; }

    #inspire{
        background-image: url("../../assets/bckpattern.png");
        background-repeat: repeat;
    }
</style>


